module.exports = __webpack_public_path__ + "static/media/Familyfleet.7d750f82.png";